"use client";

import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";

type GTMInitStateContextValue = {
  isGTMInitialized: boolean;
  setIsGTMInitialized: Dispatch<SetStateAction<boolean>>;
};

const GTMInitStateContext = createContext<GTMInitStateContextValue | undefined>(undefined);

export const GTMInitStateProvider = ({ children }: PropsWithChildren) => {
  const [isGTMInitialized, setIsGTMInitialized] = useState(false);

  const value = useMemo(() => ({ isGTMInitialized, setIsGTMInitialized }), [isGTMInitialized, setIsGTMInitialized]);

  return <GTMInitStateContext.Provider value={value}>{children}</GTMInitStateContext.Provider>;
};

export const useGTMInitState = (): GTMInitStateContextValue => {
  const ctx = useContext(GTMInitStateContext);
  if (!ctx) {
    throw new Error("useGTMInitState must be used within a GTMInitStateProvider");
  }
  return ctx;
};
